import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getStoryById, getClipById } from "@/utils/catalog";

const slideIds = ["s1", "s11", "s8"];

export default function HeroCarousel() {
  const [index, setIndex] = useState(0);
  const slides = slideIds
    .map((id) => getStoryById(id))
    .filter((item): item is NonNullable<typeof item> => Boolean(item));

  useEffect(() => {
    const timer = window.setInterval(() => {
      setIndex((prev) => (prev + 1) % slides.length);
    }, 6000);
    return () => window.clearInterval(timer);
  }, [slides.length]);

  const go = (next: number) => setIndex((next + slides.length) % slides.length);

  return (
    <section className="relative w-full overflow-hidden">
      <div className="relative h-[440px] w-full md:h-[540px]">
        {slides.map((slide, i) => {
          const clip = getClipById(slide.clipIds[0]);
          return (
            <div
              key={slide.id}
              className={`absolute inset-0 transition-opacity duration-700 ${
                i === index ? "opacity-100" : "pointer-events-none opacity-0"
              }`}
            >
              <div className="absolute inset-0 h-full w-full">
                <img
                  src={slide.cover}
                  alt={`${slide.title}剧照`}
                  title={`${slide.title} 剧情介绍`}
                  className="h-full w-full object-cover object-top"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/80 via-foreground-950/50 to-foreground-950/20"></div>
              <div className="relative mx-auto flex h-full w-full max-w-[1280px] flex-col justify-center px-4 md:px-6">
                <div className="max-w-xl">
                  <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-500 px-3 py-1 text-xs text-background-50">
                    <i className="ri-fire-line"></i>
                    本周热播推荐
                  </span>
                  <h2 className="mt-4 font-heading text-3xl font-semibold text-background-50 md:text-5xl">
                    {slide.title}
                  </h2>
                  <p className="mt-2 text-sm text-background-200">
                    {slide.season} · 第 {slide.episode} 集 · {slide.tags.join(" / ")}
                  </p>
                  <p className="mt-4 line-clamp-3 text-sm leading-relaxed text-background-100 md:text-base">
                    {slide.summary}
                  </p>
                  <div className="mt-6 flex flex-wrap gap-3">
                    <Link
                      to={`/detail/story/${slide.id}`}
                      className="inline-flex items-center gap-2 rounded-md bg-primary-500 px-5 py-2.5 text-sm text-background-50 transition hover:bg-primary-600"
                    >
                      <i className="ri-book-open-line"></i>查看剧情
                    </Link>
                    {clip && (
                      <Link
                        to={`/detail/clip/${clip.id}`}
                        className="inline-flex items-center gap-2 rounded-md border border-background-50/40 bg-background-50/10 px-5 py-2.5 text-sm text-background-50 backdrop-blur transition hover:bg-background-50/20"
                      >
                        <i className="ri-play-circle-line"></i>观看片段
                      </Link>
                    )}
                  </div>
                </div>
              </div>
            </div>
          );
        })}

        <div className="absolute bottom-6 right-4 flex items-center gap-3 md:right-6">
          <button
            type="button"
            aria-label="上一张"
            onClick={() => go(index - 1)}
            className="flex h-9 w-9 items-center justify-center rounded-full border border-background-50/40 text-background-50 transition hover:bg-background-50/20"
          >
            <i className="ri-arrow-left-s-line text-lg"></i>
          </button>
          <button
            type="button"
            aria-label="下一张"
            onClick={() => go(index + 1)}
            className="flex h-9 w-9 items-center justify-center rounded-full border border-background-50/40 text-background-50 transition hover:bg-background-50/20"
          >
            <i className="ri-arrow-right-s-line text-lg"></i>
          </button>
        </div>

        <div className="absolute bottom-7 left-1/2 flex -translate-x-1/2 items-center gap-2">
          {slides.map((slide, i) => (
            <button
              key={slide.id}
              type="button"
              aria-label={`切换到第 ${i + 1} 张`}
              onClick={() => setIndex(i)}
              className={`h-1.5 rounded-full transition-all ${
                i === index ? "w-6 bg-accent-500" : "w-1.5 bg-background-50/60"
              }`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}